import { sanitizeAndParseData } from '../../core/utils/sanitize-and-parse-data.js';
import { HoneycombTileData } from '../types/honeycomb.js';

const containsName = (data: HoneycombTileData[]) =>
  data.some(({ name }) => name !== undefined);

/**
 * Returns an array of strings as column headers
 *
 * @param data - honeycomb data
 */
const getColumnHeaders = (data: HoneycombTileData[]): string[] => {
  const columns = ['value'];

  if (containsName(data)) {
    columns.push('name');
  }

  return columns;
};

/**
 * Creates a tabular representation of the Honeycomb's data
 *
 * @param data - honeycomb data
 */
export function formatCSV(data: HoneycombTileData[]) {
  const columns = getColumnHeaders(data);

  let csv = `${columns.join(',')}\n`;

  for (const tile of data) {
    const parsedValue = sanitizeAndParseData(tile.value);
    csv += `${parsedValue}`;

    if (tile.name !== undefined) {
      const parsedName = sanitizeAndParseData(tile.name);
      csv += `,${parsedName}`;
    }

    csv += '\n';
  }

  return csv;
}
